import React from 'react';
import SectionReveal from '../SectionReveal';
import OlcekliKutu from './OlcekliKutu';
import CrmProfitCard from './CrmProfitCard';
import RadarPreview from './RadarPreview';
import SuspendAiLoader from './SuspendAiLoader';
import ServerLoader from './ServerLoader';
import { useLang } from '../LanguageProvider';
import { urunMetinleri } from './urunMetinleri';

/**
 * DÖRT ÜRÜN BÖLÜMÜ — DÖNÜŞÜMLÜ DÜZEN (İŞ 5)
 *
 * Selçuk'un kuralı: "birinde solda kaydırınca animasyon sağda yazı, diğerinde
 * tam tersi sağda animasyon solda yazı, animasyonlu geçişlerle" ve "solda biri
 * sağda biri sabit olacak, mobil tablette de ekran ne kadar küçülürse küçülsün
 * sabit yap."
 *
 * SIRA VE YÖN:
 *   1. CRM        -> animasyon SOL  / yazı SAĞ
 *   2. Radar      -> yazı SOL       / animasyon SAĞ
 *   3. Suspend AI -> animasyon SOL  / yazı SAĞ
 *   4. Server     -> yazı SOL       / animasyon SAĞ
 *
 * KAYDIRMA GEÇİŞİ: Projede zaten `src/components/SectionReveal.js` var
 * (IntersectionObserver + merkezden açılan ayraç + yukarı kayarak beliren
 * içerik). Yeni bir mekanizma yazılmadı, olan kullanıldı. Her bölüme küçük
 * bir gecikme verilerek sıralı bir açılış elde edildi.
 *
 * YAN YANA DÜZEN HER GENİŞLİKTE: Izgara HER ZAMAN iki sütundur; hiçbir
 * kırılma noktasında alt alta düşmez. 640px altında yazıya daha geniş pay
 * verilir (animasyon %42, yazı %58) ve animasyonlar `OlcekliKutu` ile
 * orantılı küçülür — düzen kırılmadan taşma sıfırlanır.
 *
 * BAĞLAMA: Bu bileşen dışa açıktır ama `App.js`'e BİLEREK bağlanmamıştır;
 * bağlamayı Selçuk kendisi yapacaktır.
 */

const BOLUMLER = [
  { anahtar: 'crm', yon: 'sol', tasarimGenisligi: 380, enBuyukOlcek: 1.15 },
  { anahtar: 'radar', yon: 'sag', tasarimGenisligi: 420, enBuyukOlcek: 1.35 },
  { anahtar: 'ai', yon: 'sol', tasarimGenisligi: 250, enBuyukOlcek: 1.5 },
  { anahtar: 'server', yon: 'sag', tasarimGenisligi: 150, enBuyukOlcek: 1.9 },
];

function Gorsel({ anahtar }) {
  if (anahtar === 'crm') return <CrmProfitCard />;
  if (anahtar === 'radar') return <RadarPreview />;
  if (anahtar === 'ai') return <SuspendAiLoader />;
  return <ServerLoader />;
}

export default function UrunBolumleri({ className = '' }) {
  const { lang } = useLang();
  const m = urunMetinleri(lang);

  return (
    <section className={`wh-urun-kok ${className}`} data-testid="urun-bolumleri">
      {BOLUMLER.map((b, i) => {
        const y = m[b.anahtar];
        return (
          <SectionReveal key={b.anahtar} className="wh-urun-bolum" delay={i * 60}>
            <div className="wh-urun-ic" data-yon={b.yon}>
              <div className="wh-urun-gorsel">
                <OlcekliKutu tasarimGenisligi={b.tasarimGenisligi} enBuyukOlcek={b.enBuyukOlcek}>
                  <Gorsel anahtar={b.anahtar} />
                </OlcekliKutu>
              </div>
              <div className="wh-urun-yazi">
                <span className="wh-urun-etiket">{y.etiket}</span>
                <h3 className="wh-urun-baslik">{y.baslik}</h3>
                <p className="wh-urun-metin">{y.metin}</p>
                <ul className="wh-urun-liste">
                  {y.maddeler.map((madde) => (
                    <li key={madde}>
                      <span className="wh-urun-nokta" aria-hidden="true" />
                      {madde}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </SectionReveal>
        );
      })}
    </section>
  );
}
